import { action, runInAction } from "mobx"
import store from "./store"

class NoticeService {
  @action
  changeDetailShow = (f) => {
    store.detailShow = f
  }
}

export default new NoticeService()
